const template = require('./search-result-template.html');
module.exports = function SearchResultDirective(helpCenterService, $sce) {
    return {
        restrict: 'E',
        scope: {
            searchTerm: '=',
            showArticle: '&'
              },
        template: template,
        link : function(scope, element) {
            scope.currentPageNumber = 1;
            scope.searchResult = {};
            scope.searchedArticles = [];
            scope.totalNumberOfArticles = 0;
            scope.totalNumberOfPages = 0;
            scope.selectedArticle = {};
            scope.$watch('searchTerm', function (searchTerm) {
                setSearchState();
                scope.searchTerm = searchTerm;
                if(scope.searchTerm!=""){
                    prepareSearchQuery();
                    helpCenterService.getHelpCenterSearch(scope.zendeskSearchQuery)
                        .then(function (response) {
                            processSearchResults(response);
                        })
                        .catch(function (error) {
                            console.error("Error fetching data:", error);
                        });
                }
            });
            scope.$watch('totalNumberOfArticles', function (totalNumberOfArticles) {
                if(totalNumberOfArticles == 0){
                    scope.$parent.showQuickAnswerAndPopularArticlesSection();
                }
                else{
                    scope.$parent.hideQuickAnswerAndPopularArticlesSection();
                }
            });
            scope.showArticle= function(article){
                scope.$parent.showArticle(article);
            }

            scope.showHelpCenter= function(){
                scope.$parent.showLandingPageTemplate();
            }

            function setSearchState() {
                scope.searchedArticles = [];
                scope.currentPageNumber = 1;
                scope.zendeskSearchQuery = '';
                scope.totalNumberOfArticles = 0;
                scope.totalNumberOfPages = 0;
                scope.searchResult = {};
            }
            function prepareSearchQuery() {
                scope.zendeskSearchQuery = 'page=' + scope.currentPageNumber + '&per_page=10&query=' + encodeURIComponent(scope.searchTerm);
            }
            function processSearchResults(response) {
                console.log("Data fetched:", response);

                if (response != null) {
                    scope.searchResult = response;
                    scope.totalNumberOfArticles = response.count;
                    scope.currentPageNumber = response.page;
                    scope.totalNumberOfPages = response.page_count;
                    scope.searchedArticles.push.apply(scope.searchedArticles, response.results);

                    updateProgressBar();
                }
            }
            function updateProgressBar() {
                var progress = (scope.searchedArticles.length / (scope.totalNumberOfArticles * 1.0)) * 100;

                setTimeout(() => {
                    const pattern = /(\d+\.?\d*)\%/gi;
                    const bar = angular.element(document).find('.help-center__pagination-progress-bar');
                    const style = bar.css('background-image').replace(pattern, progress + '%');

                    bar.css('background-image', style);
                });
            }
            scope.trustHtml = function (snippet) {
                return $sce.trustAsHtml(snippet);
            };
            scope.loadMoreSearchResult = function () {
                if (scope.currentPageNumber < scope.totalNumberOfPages) {
                    scope.currentPageNumber = scope.currentPageNumber + 1;
                    prepareSearchQuery();
                    helpCenterService.getHelpCenterSearch(scope.zendeskSearchQuery)
                        .then(function (response) {
                            processSearchResults(response);
                        })
                        .catch(function (error) {
                            console.error("Error fetching data:", error);
                        });
                }
            }

        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/search-result-directive.js
 **/